<template>
  <div class="bam-loader-icon">
    <div>
      <div class="lds-ring">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @usage
 * Use classes loader-size-** for setting size
 */
// TODO(jon.jandoc): Remove and replace with Pollen AnnularThrobber.
export default {
  name: 'LoaderIcon',
};
</script>

<style lang="scss">
.bam-loader-icon {
  align-items: center;
  display: flex;
  justify-content: center;

  $sizes: (
    'sm': 240px,
    'md': 360px,
    'lg': 480px,
  );

  @each $name, $size in $sizes {
    &.loader-size-#{$name} {
      min-height: $size;
    }
  }
}

.lds-ring {
  display: inline-block;
  height: 64px;
  position: relative;
  width: 64px;
}

.lds-ring div {
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border: 6px solid #69488e;
  border-color: #69488e transparent transparent transparent;
  border-radius: 50%;
  box-sizing: border-box;
  display: block;
  height: 51px;
  margin: 6px;
  position: absolute;
  width: 51px;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

.bam-loader-icon.is-grey {
  .lds-ring div {
    border-color: #e0e0e0 transparent transparent transparent;
  }
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
